var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/carousel-slider/slider-arrow.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "isSmallArrow")) {
output += "\n\n\t<svg class=\"o-slider__button-svg o-slider__button--small\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t\t viewBox=\"-483.4 247.1 44.7 83.9\" style=\"enable-background:new -483.4 247.1 44.7 83.9;\" xml:space=\"preserve\" role=\"img\" aria-hidden=\"true\">\n\t\t<path d=\"M-480.8,325.6c-0.8,0.8-0.8,2,0,2.8s1.9,0.8,2.6,0l36.8-39.4l-36.8-39.3c-0.8-0.8-1.9-0.8-2.6,0\n\t\t\tc-0.8,0.8-0.8,2,0,2.8l34.1,36.5L-480.8,325.6z\"></path>\n\t</svg>\n\n";
;
}
else {
output += "\n\n\t<svg class=\"o-carousel__button-svg o-carousel__button--large\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 51.903 88.196\" style=\"enable-background:new 0 0 51.903 88.196;\" xml:space=\"preserve\" role=\"img\" aria-hidden=\"true\">\n\t\t<g>\n\t\t\t<path class=\"o-carousel__button-svg--inner\" d=\"M46.95,44.047l-39.2,39.2l-2.8-2.8l36.3-36.4l-36.3-36.3l2.8-2.8L46.95,44.047z M7.75,83.247l-2.8-2.8\"></path>\n\t\t\t<polygon points=\"7.75,88.196 0.003,80.451 36.303,44.05 0,7.747 7.747,0 51.903,44.044\"></polygon>\n\t\t</g>\n\t</svg>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/carousel-slider/slider-arrow.j2"] , dependencies)